import { ActionTypeList } from '../../constants'

const initialState = {
    loading: false,
    isSuccess: false,
    successMessage: '',
    toShowMessage: false,
    error: "",
};

const userUpdateStatusPayload = (state = initialState, action) => {
    //console.log(`userUpdateStatusPayload state ${JSON.stringify(state)}`);

    switch (action.type) {
        case ActionTypeList.USER_SETTING_UPDATED:
            return {
                loading: false,
                isSuccess: true,
                successMessage: action.payload,
                toShowMessage: true,
                error: ""
            };
        case ActionTypeList.USER_SETTING_UPDATE:
            return {
                loading: true,
                isSuccess: false,
                toShowMessage: true,
                error: action.payload
            };
        case ActionTypeList.USER_SETTING_UPDATED_HIDE_MSG:
            return {
                loading: false,
                toShowMessage: false,
                isSuccess: false,
                error: "",
                successMessage: ``
            };
        default:
            return state;
    }
}

export default userUpdateStatusPayload;